var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99963 8.66675C6.73553 8.66675 7.33344 9.26391 7.33362 9.99976C7.33362 10.7358 6.73563 11.3337 5.99963 11.3337C5.26378 11.3336 4.66663 10.7356 4.66663 9.99976C4.6668 9.26401 5.26389 8.66692 5.99963 8.66675ZM9.99963 8.66675C10.7355 8.66675 11.3334 9.26391 11.3336 9.99976C11.3336 10.7358 10.7356 11.3337 9.99963 11.3337C9.26378 11.3336 8.66663 10.7356 8.66663 9.99976C8.6668 9.26401 9.26389 8.66692 9.99963 8.66675ZM13.9996 8.66675C14.7355 8.66675 15.3334 9.26391 15.3336 9.99976C15.3336 10.7358 14.7356 11.3337 13.9996 11.3337C13.2638 11.3336 12.6666 10.7356 12.6666 9.99976C12.6668 9.26401 13.2639 8.66692 13.9996 8.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.fb4f7f8e4e7a374076c08c232248a4c4.svg";
export { ForwardRef as ReactComponent };